import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Footer from '../components/Footer';
import WhatsAppWidget from '../components/WhatsAppWidget';

const API = process.env.REACT_APP_API_BASE_URL || `${process.env.FRONTEND_URL}/api`;

export default function UniversityDetailPage() {
  const { id } = useParams();
  const [u, setU] = useState(null);
  useEffect(() => {
    fetch(`${API}/institutions/${id}`)
      .then((r) => r.json())
      .then((j) => setU(j.data));
  }, [id]);
  if (!u)
    return (
      <main className="min-h-screen grid place-items-center text-[#00255a]">
        Loading university profile…
      </main>
    );
  const facts = u.facts || {};
  return (
    <div>
    <main className="min-h-screen bg-[#f7f9fb] pb-16">
      <section className="bg-[#00255a] text-white pt-24 pb-14">
        <div className="max-w-6xl mx-auto px-5">
          <Link className="text-sm text-blue-200" to="/universities">
            ← All universities
          </Link>
          <div className="mt-7 flex gap-5 items-center">
            <div className="w-24 h-24 rounded-2xl bg-white p-3 grid place-items-center overflow-hidden">
              {u.logoUrl ? (
                <img src={u.logoUrl} alt="" className="max-w-full max-h-full" />
              ) : (
                <span className="material-symbols-outlined text-[#00255a] text-5xl">
                  account_balance
                </span>
              )}
            </div>
            <div>
              <p className="text-blue-200">
                {u.country}
                {facts.location ? ` · ${facts.location}` : ""}
              </p>
              <h1 className="text-4xl font-bold">{u.name}</h1>
              <p className="mt-2">
                {facts.universityType || "Partner university"}
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="max-w-6xl mx-auto px-5 mt-8 grid lg:grid-cols-[1fr_320px] gap-7">
        <article className="bg-white rounded-2xl p-7 border">
          <h2 className="text-2xl font-bold text-[#00255a]">About {u.name}</h2>
          <p className="mt-4 leading-7 text-slate-700">
            {u.description ||
              "This profile is awaiting approved university information."}
          </p>
          {(u.globalRank || u.localRank || u.europeRank) && (
            <div className="grid grid-cols-3 gap-3 mt-8">
              {[
                ["Global", u.globalRank],
                ["Local", u.localRank],
                ["Europe", u.europeRank],
              ].map(([label, rank]) => (
                <div
                  key={label}
                  className="bg-blue-50 rounded-xl p-3 text-center"
                >
                  <p className="text-xs text-slate-500">{label} rank</p>
                  <p className="text-xl font-bold text-[#00255a]">
                    {rank || "—"}
                  </p>
                </div>
              ))}
            </div>
          )}
          <h2 className="text-2xl font-bold text-[#00255a] mt-8">
            Why students choose it
          </h2>
          <div className="mt-4 grid sm:grid-cols-2 gap-3">
            {(u.highlights || []).map((h, i) => (
              <div key={i} className="p-4 bg-blue-50 rounded-xl text-slate-700">
                <span className="text-[#365da3] mr-2">✓</span>
                {h}
              </div>
            ))}
          </div>
          {u.websiteUrl && (
            <a
              href={u.websiteUrl}
              target="_blank"
              rel="noreferrer"
              className="inline-block mt-8 text-[#365da3] font-bold"
            >
              Visit official university website ↗
            </a>
          )}
        </article>
        <aside className="bg-white rounded-2xl p-6 border h-fit">
          <p className="text-sm font-bold uppercase tracking-wide text-slate-500">
            Annual tuition
          </p>
          {u.normalFee && (
            <p className="line-through text-slate-400 mt-4">
              Normal: {u.feeCurrency} {u.normalFee}
            </p>
          )}
          <p className="text-3xl font-bold text-[#00255a] mt-1">
            {u.discountFee ? `${u.feeCurrency} ${u.discountFee}` : "Contact us"}
          </p>
          <p className="text-sm text-slate-500 mt-1">Discount fee</p>
          <Link
            to="/apply/study"
            className="block text-center mt-6 bg-[#00255a] text-white rounded-lg font-bold py-3"
          >
            Apply with IASC
          </Link>
        </aside>
      </section>
    </main>
    <Footer />
    <WhatsAppWidget />
    </div>
  );
}
